import { render, staticRenderFns } from "./ActiveResource.vue?vue&type=template&id=ea2c7a10&scoped=true"
import script from "./ActiveResource.vue?vue&type=script&lang=js"
export * from "./ActiveResource.vue?vue&type=script&lang=js"
import style0 from "./ActiveResource.vue?vue&type=style&index=0&id=ea2c7a10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea2c7a10",
  null
  
)

export default component.exports